module.exports = __webpack_public_path__ + "img/fig9.19.50cdd438.png";